import React, { useState, useEffect, useCallback } from 'react';
import { styled } from 'styled-components';
import { TeContainer } from '@topcon/tuicl-react';

import Banner from '../../pages/Overview/Banner';

type CarouselProps = {
  paths: string[];
  interval?: number;
  autoplay?: boolean;
};

const SlidesWrapper = styled(TeContainer)<{ translateX: number }>`
  transform: translateX(-${({ translateX }) => translateX}%);
  transition: transform 0.5s ease-in-out;
`;

const Carousel: React.FC<CarouselProps> = ({ paths, interval = 5000, autoplay = true }) => {
  const [current, setCurrent] = useState(0);
  const { length } = paths;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % length);
  }, [length]);

  useEffect(() => {
    if (!autoplay || length <= 1) return;
    const timer = setInterval(next, interval);
    return () => clearInterval(timer);
  }, [autoplay, interval, next, length]);

  return (
    <TeContainer fill padding={0} gap={0} overflow="hidden" borderRadius="m">
      <SlidesWrapper fill translateX={current * 100} gap={0} padding={0} width="100%">
        {paths.map((path, idx) => (
          <TeContainer key={idx} padding={0} style={{ flex: '0 0 100%' }}>
            <Banner path={path} />
          </TeContainer>
        ))}
      </SlidesWrapper>
    </TeContainer>
  );
};

export default Carousel;
